// src/router/new-tip.js
//
// Routes Vue Router du module New TIP. À inclure dans le router principal :
//
//   import newTipRoutes from './new-tip';
//   const routes = [...autresRoutes, ...newTipRoutes];
//
// Toutes les routes utilisent un meta { layout: 'admin', requiresAuth: true,
// roles: ['admin', 'super-admin'] } — adapte selon les conventions de ton
// projet (peut être { meta: { auth: true, role: 'admin' } } chez vous).

const newTipRoutes = [
  {
    path: '/admin/new-tip',
    redirect: { name: 'new-tip.dashboard' },
  },
  {
    path: '/admin/new-tip/dashboard',
    name: 'new-tip.dashboard',
    component: () => import('@/views/new-tip/Dashboard.vue'),
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Dashboard New TIP' },
  },
  {
    path: '/admin/new-tip/campaigns',
    name: 'new-tip.campaigns.index',
    component: () => import('@/views/new-tip/CampaignsList.vue'),
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Campagnes New TIP' },
  },
  {
    path: '/admin/new-tip/campaigns/create',
    name: 'new-tip.campaigns.create',
    component: () => import('@/views/new-tip/CampaignForm.vue'),
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Nouvelle campagne' },
  },
  {
    path: '/admin/new-tip/campaigns/:id',
    name: 'new-tip.campaigns.show',
    component: () => import('@/views/new-tip/CampaignDetail.vue'),
    props: true,
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Détail campagne' },
  },
  {
    path: '/admin/new-tip/campaigns/:id/edit',
    name: 'new-tip.campaigns.edit',
    component: () => import('@/views/new-tip/CampaignForm.vue'),
    props: true,
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Modifier campagne' },
  },
  {
    path: '/admin/new-tip/campaigns/:id/assignments',
    name: 'new-tip.campaigns.assignments',
    component: () => import('@/views/new-tip/AssignmentsManager.vue'),
    props: true,
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Affectations' },
  },
  {
    path: '/admin/new-tip/visits/:id',
    name: 'new-tip.visits.show',
    component: () => import('@/views/new-tip/VisitDetail.vue'),
    props: true,
    meta: { layout: 'admin', requiresAuth: true, roles: ['admin', 'super-admin'], title: 'Détail visite' },
  },
];

export default newTipRoutes;
